import { defineComponent as _defineComponent } from 'vue'
import { AnalyticsPromoAttrs } from 'JS/utilities/analytics';
import { computed } from 'vue';
import { normalizeTrailingSlash } from 'JS/utilities/url';
import { StoryCarouselStory } from 'JS/dxp/types/widgets/story-carousel-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'StoryCarouselWidgetStory',
  props: {
    story: null,
    promoAttrs: null
  },
  setup(__props: any) {

const props = __props as {
	story: StoryCarouselStory;
	promoAttrs: AnalyticsPromoAttrs;
}



const normalizedLink = computed(() => {
	return normalizeTrailingSlash(props.story.link);
});


return { __sfc: true,props, normalizedLink }
}

})